export default {
  steps: {
    0: {
      title: 'Diventa un cliente fisso',
      description: 'Visualizza la cronologia degli ordini e riordina in un tap.',
    },
    1: {
      title: 'Ottieni premi',
      description: 'Tieni traccia dei tuoi punti e riscatta i premi dal tuo portafoglio.',
    },
    2: {
      title: 'Ordina in anticipo',
      description: 'Trova il punto più vicino e ordina più velocemente che mai.',
    },
  },
  buttons: {
    skip: 'Salta',
  },
};
